__turbopack_context__.v({
  "contentContainer": "Tabs-module__pPPKBa__contentContainer",
  "contentContainerReduced": "Tabs-module__pPPKBa__contentContainerReduced",
  "tab": "Tabs-module__pPPKBa__tab",
  "tabActive": "Tabs-module__pPPKBa__tabActive",
  "tabGroup": "Tabs-module__pPPKBa__tabGroup",
  "tabNav": "Tabs-module__pPPKBa__tabNav",
});
